// Override cart empty redirect behavior
document.addEventListener('DOMContentLoaded', function() {
  // Get the cart items element
  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return;

  // Store the original updateQuantity method
  const originalUpdateQuantity = cartItems.updateQuantity;

  // Override the updateQuantity method
  cartItems.updateQuantity = function(line, quantity, name, variantId) {
    // Call the original method
    originalUpdateQuantity.call(this, line, quantity, name, variantId);

    // Add a listener for the cart update
    this.addEventListener('cart:updated', function(event) {
      const parsedState = JSON.parse(event.detail.state);
      
      // If cart is empty, redirect to home page
      if (parsedState.item_count === 0) {
        window.location.href = '/';
      }
    });
  };
}); 